import { useCallback, useEffect, useState } from "react";

import {
  fetchInventoryValueReportOptions,
  isReportRequestCanceled,
} from "../api/inventory-value-report-api";

const EMPTY_STATE = { options: null, loading: false, error: null };

/** Options are outlet-specific (authorized warehouses), so they reload per outlet. */
export const useInventoryValueReportOptions = (outletId) => {
  const [state, setState] = useState(EMPTY_STATE);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!outletId) {
      setState(EMPTY_STATE);
      return undefined;
    }

    const controller = new AbortController();
    setState({ options: null, loading: true, error: null });

    fetchInventoryValueReportOptions({ outletId, signal: controller.signal })
      .then((options) => {
        if (!controller.signal.aborted) {
          setState({ options, loading: false, error: null });
        }
      })
      .catch((error) => {
        if (!controller.signal.aborted && !isReportRequestCanceled(error)) {
          setState({ options: null, loading: false, error });
        }
      });

    return () => controller.abort();
  }, [outletId, reloadToken]);

  const reload = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, reload };
};
